import InfoSolidSmallIcon from '@cp/src/assets/icons/InfoSolidSmallIcon';
import { formatAmount } from '@cp/src/utils/commonUtils';
import { Typography } from '@navi/web-ui/lib/primitives';
import React from 'react';
import styles from './index.module.scss';

interface IAdjustmentEmiView {
  waivedAmount: number;
  totalUnpaidAmount: number;
  isColendingFlow?: boolean;
}

const AdjustEmiView: React.FC<IAdjustmentEmiView> = ({
  waivedAmount,
  totalUnpaidAmount,
  isColendingFlow
}) => {
  const adjustmentAmount = waivedAmount - totalUnpaidAmount;
  const waivedInstantlyAmount = totalUnpaidAmount;

  return (
    <div className="mt-5">
      <Typography variant="p2" color="var(--light-grayscale-content-2)" as="span">
        {`You're waiving `}
        <Typography variant="h3" color="var(--green-base)" as="span">
          {formatAmount(waivedAmount)}
        </Typography>
      </Typography>
      <div className="flex bg-[var(--grayscale-background-secondary)] p-3 rounded-lg mt-4">
        <div>
          <Typography variant="p4" color="var(--grayscale-8)" className="mb-1">
            Waived instantly
          </Typography>
          <Typography variant="h3">{formatAmount(waivedInstantlyAmount)}</Typography>
        </div>
        <div className="w-0.25 bg-[var(--border)] mx-6" />
        <div>
          <Typography variant="p4" color="var(--grayscale-8)" className="mb-1">
            {isColendingFlow ? 'To be refunded' : 'Adjusted to next EMI'}
          </Typography>
          <Typography variant="h3">{formatAmount(adjustmentAmount)}</Typography>
        </div>
      </div>
      {isColendingFlow && (
        <div className={styles.refundInfoBox}>
          <InfoSolidSmallIcon />
          <Typography variant="p5" className="flex-1" color={'var(--blue-base)'}>
            Navi customer support team will connect with the customer within 2 business days for the
            refund. Customer need not reach out to Navi.
          </Typography>
        </div>
      )}
    </div>
  );
};

export default AdjustEmiView;
